import { defineMessages } from 'react-intl';

export default defineMessages({
  giveFeedbackButton: {
    id: 'frontbucket.navigationFeedbackCollector.giveFeedbackButton',
    description: 'Text for button to open feedback modal',
    defaultMessage: 'Give feedback',
  },
  giveFeedbackPlaceholder: {
    id: 'frontbucket.navigationFeedbackCollector.giveFeedbackButtonPlaceholder',
    description: 'Text for placeholder in give feedback modal',
    defaultMessage: "Let us know what's on your mind",
  },
  giveFeedbackTitleDetailsOne: {
    id: 'frontbucket.navigationFeedbackCollector.giveFeedbackTitleDetailsOne',
    description: 'Text for title details in give feedback modal',
    defaultMessage:
      'Your thoughts are valuable in helping improve our products',
  },
  giveFeedbackTitleDetailsTwo: {
    id: 'frontbucket.navigationFeedbackCollector.giveFeedbackTitleDetailsTwo',
    description: 'Text for title details in give feedback modal',
    defaultMessage:
      "If you're looking to get help or want to report a bug, visit our {supportSiteLink}",
  },
  supportSiteLinkText: {
    id: 'frontbucket.navigationFeedbackCollector.supportSiteLink',
    description: 'Link to support site',
    defaultMessage: 'support site.',
  },
  canContactLabel: {
    id: 'frontbucket.navigationFeedbackCollector.canContactLabel',
    description: 'Text for the contact label',
    defaultMessage:
      'Atlassian can contact me about this feedback. See our {privacyPolicyLink}',
  },
  privacyPolicyLinkText: {
    id: 'frontbucket.navigationFeedbackCollector.privacyPolicyLink',
    description: 'Link to privacy policy',
    defaultMessage: 'privacy policy',
  },
  enrolLabel: {
    id: 'frontbucket.navigationFeedbackCollector.enrolLabel',
    description: 'Text for the enrol label',
    defaultMessage:
      "I'd like to help improve Atlassian products by joining the {atlassianResearchGroupLink}",
  },
  atlassianResearchGroupLinkText: {
    id: 'frontbucket.navigationFeedbackCollector.atlassianResearchGroupLink',
    description: 'Link to Atlassian Research Group',
    defaultMessage: 'Atlassian Research Group',
  },
});
